import FirstNameField from '@/components/checkout/fields/personal/FirstNameField';
import SurnameField from '@/components/checkout/fields/personal/SurnameField';
import PhoneField from '@/components/checkout/fields/personal/PhoneField';
export {FirstNameField, SurnameField, PhoneField};
